var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.point)?_c('p',[_c('b',[_vm._v("Wybrany punkt:")]),_vm._v(" "+_vm._s(_vm.point.name))]):_vm._e(),_c('button',{attrs:{"type":"button","id":"furgonetka-map"}},[_vm._v("Wybierz punkt odbioru")])])}
var staticRenderFns = []

export { render, staticRenderFns }